<template>
  <div class="video">
    <div class="title">{{ $t('addVideo') }}</div>
    <button @click="addYouTubeVideo(article)">
      {{ $t('addYoutubeVideo') }}
      <img src="https://img.icons8.com/external-prettycons-flat-prettycons/94/000000/external-youtube-multimedia-prettycons-flat-prettycons.png" />
    </button>
    <div v-if="getIframeValue(article) && !updateVideo" class="iframe-content youtube" v-html="getIframeValue(article)"></div>
    <div v-else class="iframe-content youtube">
      <iframe class="video-media" :src="youTubeUrl" frameborder="0" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    updateVideo: {
      type: Boolean,
    },

    article: {
      type: Object,
    },
  },

  data() {
    return {
      iframeHTML: '',
      youTubeUrl: '',
    };
  },

  methods: {
    getYoutubeId(url) {
      if (!url) return '';

      const myregexp = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/gi;

      const result = myregexp.exec(url);
      if (!result) return '';

      return result[1];
    },

    addYouTubeVideo(article) {
      const url = window.prompt('URL');
      if (article) {
        this.$emit('setVideoUpdate', true);
        const array = article.content.split('<iframe');
        this.$emit('newContent', array[0]);
      }

      if (url) {
        const youTubeUrl = `https://www.youtube.com/embed/${this.getYoutubeId(url)}?color=white`;
        this.iframeHTML = `<iframe class="video-media" src="${youTubeUrl}" frameborder="0" allowfullscreen></iframe>`;
        this.youTubeUrl = youTubeUrl;
        this.$emit('input', this.iframeHTML);
      }
    },

    getIframeValue(article) {
      if (!article) return;

      const array = article.content.split('<iframe');
      if (array.length > 1) {
        const iframe = array[array.length - 1];
        return '<iframe' + iframe;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.iframe-content {
  margin-top: 12px;
  display: flex;
  align-items: center;
  flex-grow: 1;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border: 1px solid colors.$lightgrey-color;
  border-radius: 5px;
  padding: 30px;
  transition: all 0.3s;
  overflow-y: auto;
}

.video {
  margin-top: 40px;
}

.title {
  color: colors.$darkblue-color;
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 24px;
}

button {
  width: max-content;
  box-sizing: border-box;
  border: 1px solid colors.$lightgrey-color;
  margin: 0 6px;
  height: 36px;
  min-width: 36px;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.3s;
  object-fit: contain;
  font-size: 14px;
  display: flex;
  align-items: center;

  &:hover,
  &.is-active {
    background: colors.$lightgrey-color;
  }

  img {
    object-fit: contain;
    height: 100%;
    margin-left: 10px;
  }
}

.youtube {
  width: 100%;
  aspect-ratio: 16/9;
  margin-bottom: 24px;
  border-radius: 4px;
  overflow: hidden;
  height: 100%;
}

:deep(.youtube) {
  .video-media {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
